import { Form, Input } from 'antd';
import React, { useState } from 'react';
import './index.scss';

interface IProps {
  readonly value: string;
  readonly validator: (rule: any, value: string) => Promise<any>;
  readonly onSubmit: (value: string) => Promise<boolean>;
}

export const EditInput = (props: IProps) => {
  const [value, setValue] = useState<string>(props.value);
  const [settingForm] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value.trim());
  };

  const onBlur = async () => {
    const values = await settingForm.validateFields(['Name']);
    const curValue = values.Name.trim();
    setLoading(true);
    setValue(curValue);
    await props.onSubmit(curValue);
    setLoading(false);
  };

  return (
    <Form
      form={settingForm}
      name="basic"
      autoComplete="off"
      labelAlign="right"
      colon={false}
      layout="vertical"
      requiredMark={false}
      initialValues={{
        Name: props.value,
      }}
    >
      <Form.Item
        style={{ marginBottom: 0 }}
        name="Name"
        rules={[{ required: true, validator: props.validator }]}
      >
        <Input
          autoFocus
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          spellCheck="false"
          disabled={loading}
        />
      </Form.Item>
    </Form>
  );
};
